import { useExperiences } from 'react-chansey/lib/provider'

/*
 * Check if the user is assigned to a particular variant for a given
 * experiment. An array of variant names may be provided, in which case the
 * hook will return true if the user is assigned to any of them.
 */
export const useInBucket = (experienceName, variantName) => {
  const experiences = useExperiences()
  const variantNames = Array.isArray(variantName) ? variantName : [variantName]
  const value = experiences[experienceName]?.value
  return variantNames.some((name) => name === value)
}
